import {JsonObject} from "json2typescript";

@JsonObject("EmptyOutput")
export class EmptyOutput {}
